import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const ManagePodcast: React.FC<Props> = ({ }: Props) => {
    return (
        <ManageBooks
            button_add_name='เพิ่มพอดแคสต์'
            category={ELibraryCategory.PODCAST}
            menu_name={'จัดการพอดแคสต์'}
            path_create={routeName.e_library.manage_podcast_create}
        />
    )
}

export default ManagePodcast